"use strict";

require("xzoom");

const breakpoints = require("../utils/breakpoints");
var xzoomOptions = {
    position: "lens",
    lens: "transparent",
    lensShape: "circle",
    defaultScale: "-1",
    zoomWidth: 400,
    zoomHeight: 400
};

/**
 * Initialize zoom functionality
 *
 * @param {Object} item - item with image inside
 */
function initializeXZoom(item) {
    var image = item.find(".active .img-fluid");
    var xoriginalURL = image.attr("src");

    image.addClass("xzoom").attr("xoriginal", xoriginalURL);
    image.parent().addClass("xzoom-wrapper");

    if (!breakpoints.isLargeBreakpoint()) {
        xzoomOptions.position = "right";
    }

    image.xzoom(xzoomOptions);

    // set each instance
    var instance = image.data("xzoom");

    instance.eventclick = function (element) {
        if (!breakpoints.isLargeBreakpoint() && $(".xzoom-preview .xzoom-close").length === 0) {
            var $zoomPreview = $(element).find(".xzoom-preview");

            // get the dimensions of the wrapper
            var zoomPreviewWidth = $zoomPreview.width();
            var zoomPreviewHeight = $zoomPreview.height();

            // get the dimensions of the scroll
            var zoomPreviewScrollWidth = $zoomPreview.get(0).scrollWidth;
            var zoomPreviewScrollHeight =$zoomPreview.get(0).scrollHeight;

            // calculate the middle of the scroll
            var zoomPreviewScrollLeft = (zoomPreviewScrollWidth - zoomPreviewWidth) / 2;
            var zoomPreviewScrollRight = (zoomPreviewScrollHeight - zoomPreviewHeight) / 2;

            // position the scroll to the middle vertically and horizontally
            $zoomPreview.scrollLeft(zoomPreviewScrollLeft).scrollTop(zoomPreviewScrollRight);

            // append the close button
            $(element).append("<span class='xzoom-close'>&times;</span>");

            // add action to the close button
            $(element).on("click", ".xzoom-close", function () {
                instance.closezoom();
            });
        }
    };

    instance.eventscroll = function (element) {
        element.off('mousewheel DOMMouseScroll');
    };
}

/**
 * Zoom functionality for image carousel
 *
 * @param {Object} carousel - image carousel
 */
function zoomCarouselImage(carousel) {
    initializeXZoom(carousel);

    carousel.on("slide.bs.carousel", function () {
        $(this).find(".active .img-fluid").attr("xoriginal", "");
    });

    carousel.on("slid.bs.carousel", function () {
        initializeXZoom($(this));
    });
}

module.exports = {
    xZoomInit: function () {
        var $carousel = $(".primary-images .carousel");

        $carousel.each(function () {
            var $item = $(this);

            zoomCarouselImage($item);
        });
    },
    onVariationUpdate: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            var $carousel = response.container;

            zoomCarouselImage($carousel);
        });
    }
};
